import { render, staticRenderFns } from "./planTransForAutoPur.vue?vue&type=template&id=0dec952d&scoped=true&"
import script from "./planTransForAutoPur.vue?vue&type=script&lang=js&"
export * from "./planTransForAutoPur.vue?vue&type=script&lang=js&"
import style0 from "./planTransForAutoPur.vue?vue&type=style&index=0&id=0dec952d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dec952d",
  null
  
)

component.options.__file = "planTransForAutoPur.vue"
export default component.exports